import { isNumberValidator } from '@/validators';
export const baseColumnList = (ctx, cs) => {
  console.log(cs);
  return [
    {
      name: '是否有逾期利息条款',
      prop: 'isOverdueInterest',
      type: 'checkbox',
      span: 8,
      disabled: ctx.isDisableOverdueInterest,
    },
    {
      prop: 'overduePaymentInterest',
      name: '逾期付款利息',
      type: 'input',
      disabled: !ctx.overdueForm.isOverdueInterest,
      span: 8,
    },
    {
      prop: 'receivableDate',
      name: '应收日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: !ctx.overdueForm.isOverdueInterest || ctx.isDisableOverdueInterest,
      span: 8,
    },
    {
      prop: 'receivableRule',
      name: '应收规则',
      type: 'select',
      span: 8,
      disabled: !ctx.overdueForm.isOverdueInterest || ctx.isDisableOverdueInterest,
      options: ctx.dictListMap?.receivableRule || [],
    },
    {
      prop: 'receivableStartDate',
      name: '罚息出发点',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: !ctx.overdueForm.isOverdueInterest || ctx.isDisableOverdueInterest,
      span: 8,
    },
    {
      prop: 'defaultInterestRate',
      name: '罚息利率',
      type: 'input',
      disabled: !ctx.overdueForm.isOverdueInterest || ctx.isDisableOverdueInterest,
      span: 8,
    },
  ];
};

// 表单校验
export const baseFormRule = (ctx) => {
  return {
    overduePaymentInterest: [
      {
        required: ctx.overdueForm.isOverdueInterest,
        message: '必填字段',
        trigger: 'change',
      },
      { validator: isNumberValidator, trigger: ['blur', 'change'] },
    ],
    receivableDate: [
      {
        required: ctx.overdueForm.isOverdueInterest,
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    receivableRule: [
      {
        required: ctx.overdueForm.isOverdueInterest,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    receivableStartDate: [
      {
        required: ctx.overdueForm.isOverdueInterest,
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    defaultInterestRate: [
      {
        required: ctx.overdueForm.isOverdueInterest,
        message: '必填字段',
        trigger: 'blur',
      },
      { validator: isNumberValidator, trigger: ['blur', 'change'] },
    ],
  };
};
